import { apiToken, promoCodeUrl, validatePromoCodeUrl } from "../config";

// get all promo codes start
export const getAllPromoCode = async ({ page, limit, isActive } = {}) => {
  try {
    let url = `${promoCodeUrl}`;
    const queryParts = [];

    if (page !== undefined) queryParts.push(`page=${page}`);
    if (limit !== undefined) queryParts.push(`limit=${limit}`);
    if (typeof isActive === 'boolean') queryParts.push(`isActive=${isActive}`);

    if (queryParts.length > 0) {
      url += `?${queryParts.join('&')}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) {
      throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    }
    return res;
  } catch (e) {
    console.error("Error fetching promo codes:", e);
    throw e;
  }
};

// get all promo codes end

// create promo code start
export const createPromoCode = async (formData) => {
  try {
    const response = await fetch(promoCodeUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(formData),
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error creating promo code:", e);
    throw e;
  }
};
// create promo code end

// get promo code by id start
export const getPromoCodeById = async (id) => {
  try {
    const response = await fetch(`${promoCodeUrl}/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error fetching promo code by ID:", e);
    throw e;
  }
};
// get promo code by id end

// update promo code start
export const updatePromoCode = async (id, formData) => {
  try {
    const response = await fetch(`${promoCodeUrl}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(formData),
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error updating promo code:", e);
    throw e;
  }
};
// update promo code end

// delete promo code start
export const deletePromoCode = async (id) => {
  try {
    const response = await fetch(`${promoCodeUrl}/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error deleting promo code:", e);
    throw e;
  }
};
// delete promo code end

// validate promo code start
export const validatePromoCode = async (code) => {
  try {
    const response = await fetch(`${validatePromoCodeUrl}${encodeURIComponent(code)}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error validating promo code:", e);
    throw e;
  }
};
// validate promo code end
